<template>
  <!--
    <UOverlayProvider> retiré : ce composant n'existe pas dans @nuxt/ui 3.0.0-alpha.12
    (0 composant Overlay* sur 55) — Vue ne le résolvait pas et le rendait comme une
    balise HTML inconnue (warning "Failed to resolve component"). Dans cette version
    les overlays passent par useModal/useSlideover, fournis par <UApp>.
  -->
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script setup>
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Retailer Locator` : 'Retailer Locator';
  }
})
</script>